import { ReactComponent as IcBuildingInfo } from '@/assets/images/building-circle-exclamation.svg';
import { ReactComponent as IcBuildingCheck } from '@/assets/images/building-circle-check.svg';
import { ReactComponent as IcBuildingUser } from '@/assets/images/building-user.svg';
import { useDevice, useThemeToken } from '@/hooks';
import { useTranslation } from 'react-i18next';

export function BoxIcon({ groupStatus = null, memberStatus = null, info = false }) {
  const { colorPrimary } = useThemeToken();
  const { isMobile } = useDevice();
  const classNames = `${isMobile() ? 'w-[50px] pb-0' : 'w-[70px] pb-5'} mx-auto`;
  const styles = { fill: colorPrimary };
  if (info) {
    return <IcBuildingInfo style={styles} className={classNames} />;
  }
  switch (groupStatus) {
    case 'WAITING':
      if (memberStatus === 'APPROVED')
        return <IcBuildingInfo style={styles} className={classNames} />;
      else
        return <IcBuildingUser style={styles} className={classNames} />;
    case 'APPROVED':
      return <IcBuildingUser style={styles} className={classNames} />;
    case 'FINAL':
      return <IcBuildingCheck style={styles} className={classNames} />;
  }
  return '';
}

export function BoxDescription({ groupStatus, memberStatus, solitary = false }) {
  const [t] = useTranslation(['common', 'dormitory']);

  if (solitary) {
    switch (memberStatus) {
      case 'WAITING':
        return t('dormitory:hints.solitary-member-waiting');
      case 'APPROVED':
        return t('dormitory:hints.solitary-member-approved');
      case 'FINAL':
        return t('dormitory:hints.solitary-member-final');
    }
  }
  else {
    switch (groupStatus) {
      case 'WAITING':
        if (memberStatus !== 'APPROVED')
          return t('dormitory:hints.member-waiting');
        else
          return t('dormitory:hints.member-approved');
      case 'APPROVED':
        return t('dormitory:hints.group-approved');
      case 'FINAL':
        return t('dormitory:hints.group-final');
    }
  }
  return '';
}
